import { useState } from 'react';
import {useTranslation} from "react-i18next";

type ExpandableTextProps = {
    text: string | null;
    maxLength: number;
    classNames?: string;
}

const ExpandableText = ({ text, maxLength, classNames = "" }: ExpandableTextProps) => {
    const {t} = useTranslation();
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    };

    const truncatedText = text && text.length > maxLength ? text.slice(0, maxLength) + '...' : text;

    return (
        <>
            <p className={`mt-2 whitespace-pre-wrap ${classNames}`}>
                {isExpanded ? text : truncatedText}
            </p>
            {text && text.length > maxLength && (
                <button
                    onClick={toggleExpand}
                    className={`${classNames} mt-2 text-blue-500 dark:text-blue-300 hover:underline"`}
                >
                    {isExpanded ? t("common.readLess") : t("common.readMore")}
                </button>
            )}
        </>
    );
};

export default ExpandableText;
